import { Fragment } from 'react';
import { TemplateLocale } from 'modules/graphql';
import { AlignTypes } from 'ui/tableHeader';
import { NA } from 'modules/experiments/constants';

import {
  BaseCell,
  FlexCellWrapper,
  SecondaryContent,
  PrimaryTextSecondaryColor,
  PrimaryText,
} from './Styled';

type RowCellProps = {
  primaryText?: string;
  secondaryText?: string | number | JSX.Element | TemplateLocale | null;
  align?: AlignTypes;
  dataTestId?: string;
  children?: React.ReactNode;
  isWinner?: string;
  greyOutContent?: boolean;
};

export const RowCell = ({
  primaryText,
  secondaryText,
  align,
  dataTestId,
  children,
  /** used to highlight the whole row for experiment winner. */
  isWinner,
  greyOutContent = false,
}: RowCellProps) => {
  const displaySecondaryColorForPrimary = primaryText === NA || greyOutContent;
  return (
    <BaseCell data-test={dataTestId || 'row-cell'} data-is-winner={isWinner}>
      <FlexCellWrapper align={align}>
        {children || (
          <Fragment>
            {displaySecondaryColorForPrimary ? (
              <PrimaryTextSecondaryColor>{primaryText}</PrimaryTextSecondaryColor>
            ) : (
              <PrimaryText>{primaryText}</PrimaryText>
            )}
            <SecondaryContent>
              <>{secondaryText}</>
            </SecondaryContent>
          </Fragment>
        )}
      </FlexCellWrapper>
    </BaseCell>
  );
};
